const el = document.querySelector('.modal.rappel')

if (el) {
  document.addEventListener('click', (e) => {
    if (e.target.dataset?.action === 'open-rappel') {
      el.classList.add('open')
    }
  })

  document.addEventListener('click', (e) => {
    if (e.target.dataset?.action === 'close-rappel') {
      el.classList.remove('open', 'ok')
    }
  })

  document.addEventListener('click', (e) => {
    if (e.target.dataset?.action === 'close') {
      e.target.closest('.modal.open')?.classList.remove('open', 'ok')
    }
  })
}
